<template>
    <Overlay :show="loader.show" :opacity=".9"/>
    <div class="loader" v-if="loader.show">
        <img src="@/assets/Images/Loader.png" :alt="`Loader - ${loader.type}`" :title="`Loader - ${loader.type}`" width="100" height="100" v-if="loader.type === 'Spinner'"/>

        <!-- Logo loader -->
        <div class="loader-type-logo" v-else-if="loader.type === 'Logo'">
            <img src="@/assets/Images/LoaderRing.png" :alt="`Loader - ${loader.type} - Ring`" :title="`Loader - ${loader.type} - Ring`" width="100" height="100"/>
            <img class="plane" src="@/assets/Images/LoaderPlane.png" :alt="`Loader - ${loader.type} - Plane`" :title="`Loader - ${loader.type} - Plane`" width="100" height="100"/>
            <p id="loader-message">Loading portfolio<span id="loader-message-indicator"></span></p>
        </div>

    </div>
</template>

<script>
import $ from "jquery";
import Overlay from "@/components/Overlay.vue";

export default {
    name: "Loader",
    props: { loader: Object },
    components: { Overlay },
    data: () => ({
        pageData: null,
        intervals: {
            logo: null,
            message: null
        },
        angle: 0
    }),
    methods: {
        Start: function() {
            if (this.loader.type === "Spinner") {
                $(this.loader.content).addClass("disabled");
                this.angle = 0;

                // Animate spinner
                const pageData = this;
                const spinner = function() {
                    $(".loader img").css({
                        "-webkit-transform": `rotate(${pageData.angle}deg)`,
                        "-moz-transform": `rotate(${pageData.angle}deg)`,
                        "-ms-transform": `rotate(${pageData.angle}deg)`
                    });
                    pageData.angle++;
                };
                this.intervals.logo = window.setInterval(spinner, 5);

            } else { // Logo

                // Animate message
                let messageIndicator, m;
                messageIndicator = "";
                m = 0;
                const messaging = function() {
                    m++;
                    if (m < 4) {
                        messageIndicator += ".";
                    } else {
                        m = 0;
                        messageIndicator = "";
                    }
                    $("#loader-message-indicator").text(messageIndicator);
                };
                this.intervals.message = window.setInterval(messaging, 600);

            }
        },
        Stop: function() {
            $(this.loader.content).removeClass("disabled");
            this.angle = 0;
            window.clearInterval(this.intervals.logo);
            window.clearInterval(this.intervals.message);
        }
    },
    updated() {
        if (this.loader.show) {
            this.Start(this.loader.content);
        } else {
            this.Stop();
        }
    }
};
</script>